import { Card, CardContent } from '@mui/material';
import { MapContainer, TileLayer, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'
import '../../../themes/map-styles.css';
import { LatLngExpression, Map as LeafletMap } from 'leaflet';
import { useCallback, useState } from 'react';
import { SchoolDataDto, SchoolsDataDistribution } from '../../../models/schools-data';
import { LegendPanel } from '../../../components/map-legend-panel/map-legend-panel';
import { useDataType } from '../../../hooks/use-data-type';
import { useColor } from '../../../hooks/use-color';
import { drawShoolFeature } from './school-feature/draw-school-feature';
import { useTheme } from 'react-admin';
import { MapDataLoadingPanel } from '../../../components/map-data-loading-panel/map-data-loading-panel';
import { useMapOpacity } from '@/hooks/use-map-opacity';


export const SchoolsDataMap = ({ dataDistribution, isLoading }: { dataDistribution: SchoolsDataDistribution, isLoading?: boolean }) => {
  const [, setMap] = useState<LeafletMap | null>(null);
  const [initialCenter] = useState<LatLngExpression>([29.6827427, -95.4643671]);
  const [ getColorByValue ] = useColor();
  const [_, getDataTypeString] = useDataType();
  const [mapOpacity] = useMapOpacity();

  const [theme] = useTheme();

  const getSchoolSize = useCallback((s: SchoolDataDto) => {
    const radiusMax = 3000.0;
    const radiusMin = 100.0;
    if (!dataDistribution.stats) return 1.0;
    return radiusMin + s.dataCount * (radiusMax - radiusMin) / dataDistribution.stats.dataCountMax;
  }, [dataDistribution]);

  const getSchoolToolTip = useCallback((s: SchoolDataDto) => (
    <Tooltip>
      {s.schoolName}<b>{` (${s.schoolRating})`} </b>
      <br />Value: <b>{getDataTypeString(s.dataMean)}</b>
      <br />Data count: <b>{s.dataCount}</b>
    </Tooltip>
  ), [getDataTypeString]);

  const getSchoolColor = useCallback((data: SchoolDataDto) => {
    const color = getColorByValue(data.dataMean);
    return {
      color,
      opacity: mapOpacity,
      fillColor: color,
      fillOpacity: mapOpacity
    }
  }, [dataDistribution, getColorByValue, mapOpacity]);

  return (
    <Card>
      <CardContent>
        <MapContainer
          center={initialCenter}
          zoom={10}
          style={{ width: '100%', height: '75vh' }}
          ref={setMap}
          preferCanvas={true}
          key={theme} // use key to force re-render on theme change
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            className={ theme === 'dark' ? 'map-tiles' : ''}
          />
          {dataDistribution.data && dataDistribution.data.map((s) => drawShoolFeature(s, getSchoolSize(s), getSchoolColor(s), getSchoolToolTip(s)))}
          <LegendPanel />
          {/* <MapInfoPanelControl zipDataMap={zipDataMap} dataType={dataType} /> */}
          <MapDataLoadingPanel isLoading={isLoading} />
        </MapContainer>
      </CardContent>
    </Card>
  );
};
